import AlertTitle from '@mui/material/AlertTitle';

import { ActionableMessages } from './ActionableMessages';
import type { ActionableMessage } from './ActionableMessages';
import { InfoAlert } from './InfoAlert';

export type Notice = ActionableMessage;

interface Props {
  readonly notices: readonly Notice[];
}

// The informations of a screen, listed in a single alert: nothing without any. Closed, it shows
// again once its messages change.
export const NoticesAlert = ({ notices }: Readonly<Props>) =>
  notices.length ? (
    <InfoAlert key={notices.map(({ message }) => message).join()}>
      <AlertTitle>À noter</AlertTitle>
      <ActionableMessages items={notices} />
    </InfoAlert>
  ) : null;
